<script setup>
import StarReview from "@/Components/Icons/StarReview.vue";
import {computed} from "vue";

const props = defineProps({
    rating: {
        type: String || Number,
    }
})

const styleStarReview = computed(() => {
    const rating = parseFloat(props.rating)
        return rating <= 2 ? 'w-3 h-3 fill-red-500' : rating <= 3 ? 'w-3 h-3 fill-orange-500' : rating <= 4 ? 'w-3 h-3 fill-yellow-400' : 'w-3 h-3 fill-green-500'
    }
)
const styleTextRating = computed(() => {
    const rating = parseFloat(props.rating)
        return rating <= 2 ? 'text-red-500' : rating <= 3 ? 'text-orange-500' : rating <= 4 ? 'text-yellow-400' : 'text-green-500'
    }
)
</script>


<template>
    <span class="flex items-center">
        <StarReview :class="styleStarReview"/>
        <span :class="styleTextRating" class="font-semibold text-xs ml-1 mr-2 leading-3">
            {{ props.rating.toString().replace('.', ',') }}
        </span>
    </span>
</template>
